// extracted by mini-css-extract-plugin
module.exports =  {"banner":"_93444fe79c--banner--rpCGU","header":"_93444fe79c--header--VzUL2","text":"_93444fe79c--text--PkavE"};